export default __webpack_public_path__ + "static/media/AvatarKids-03.fea7b79f.png";